/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component to display an instruction how to use a specific component.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-instruction{background-color:#f8f9fa;position:relative;font-size:.8rem;overflow:hidden;margin-bottom:1rem}  .sym-instruction h1{font-size:1.5rem}  .sym-instruction h2{font-size:1.2rem}  .sym-instruction ul.sym-tips{list-style-type:none;padding:0;margin:0;color:#6c757d}  .sym-instruction .sym-content{position:relative}  .sym-instruction i.icon.sym-watermark{color:#f2f4f6;position:absolute;right:20px;bottom:4px;font-size:6rem}"];
export { styles as styles };
